/** @jsx jsx */
import { Grid, Heading, Link, Paragraph, Stack, WysiwygViewer } from "@eworkit/iris";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { ResponsiveCard } from "@/components/ResponsiveCard";
import { PublicProfile } from "@/data/public-profiles";

export interface AboutUsSectionProps {
  company: PublicProfile;
}

export const AboutUsSection: FC<AboutUsSectionProps> = ({ company }) => {
  const { t } = useTranslation("public");

  const websiteHref = company.website?.match(/^https?:\/\//g) ? company.website : `//${company.website}`;

  return (
    <ResponsiveCard>
      <Stack gap="md">
        <Heading size="h-sm">{t("CLIENT_PAGE.DETAILS.ABOUT_US.HEADER")}</Heading>

        <WysiwygViewer value={company.aboutUs} />

        <Grid columns={["1fr", null, null, "1fr 1fr"]}>
          {company.companySize && (
            <Stack gap="xxs">
              <Paragraph color="n700">{t("CLIENT_PAGE.DETAILS.ABOUT_US.LABEL_COMPANY_SIZE")}</Paragraph>
              <Paragraph>{t(`CLIENT_PAGE.COMPANY_SIZE.${company.companySize}`)}</Paragraph>
            </Stack>
          )}

          {company.website && (
            <Stack gap="xxs">
              <Paragraph color="n700">{t("CLIENT_PAGE.DETAILS.ABOUT_US.LABEL_WEBSITE")}</Paragraph>
              <Link href={websiteHref} target="_blank" rel="noopener noreferrer">
                {company.website}
              </Link>
            </Stack>
          )}

          {company.phoneNumber && (
            <Stack gap="xxs">
              <Paragraph color="n700">{t("CLIENT_PAGE.DETAILS.ABOUT_US.LABEL_PHONE")}</Paragraph>
              <Paragraph>{company.phoneNumber}</Paragraph>
            </Stack>
          )}
        </Grid>
      </Stack>
    </ResponsiveCard>
  );
};
